import React from 'react';
import { motion } from "motion/react";

interface FormInputProps {
  label: string;
  id: string;
  [key: string]: unknown;
}

const FormInput: React.FC<FormInputProps> = ({ label, id, ...props }) => (
  <motion.div 
    className='w-full'
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
  >
    <motion.label 
      htmlFor={id} 
      className="block text-sm font-medium text-gray-400 mb-2"
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.1, duration: 0.3 }}
    >
      {label}
    </motion.label>
    <motion.input 
      id={id} 
      className="w-full bg-gray-900/50 border border-gray-700 rounded-lg py-2.5 px-4 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-violet-500/50 focus:border-violet-500 transition-all duration-300" 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      whileFocus={{ 
        scale: 1.02,
        borderColor: "rgb(139, 92, 246)",
        boxShadow: "0 0 0 3px rgba(139, 92, 246, 0.1)",
        transition: { type: "spring", stiffness: 400, damping: 10 }
      }}
      whileHover={{
        borderColor: "rgb(107, 114, 128)",
        transition: { duration: 0.2 }
      }}
      transition={{ delay: 0.2, duration: 0.3 }}
      {...props} 
    />
  </motion.div>
);

export default FormInput;
